import {  axiosAjaxCall } from './common.service'

export const VideoService = {
    getVideoLogsData,
}

function getVideoLogsData(data) {
    return axiosAjaxCall("get_videos_logs", data);
}
